import { useSyncExternalStore } from 'react';

/**
 * The current time in ms, re-rendering the caller every `intervalMs`. Backed by
 * `useSyncExternalStore` (no setState-in-effect): the snapshot is the time
 * quantized to the interval, so it is stable between ticks.
 */
export function useNow(intervalMs: number): number {
  return useSyncExternalStore(
    (onChange) => {
      const id = setInterval(onChange, intervalMs);
      return () => clearInterval(id);
    },
    () => Math.floor(Date.now() / intervalMs) * intervalMs,
    () => 0,
  );
}
